<nw-content-block [border]="border" [heading]="title">
    <div class="nw-turtl-block__container">
        @if (content) {
            <div [innerHTML]="content | sanitizeHtml"></div>
        }
        @if (turtleurl) {
            <iframe
                #iframe
                class="nw-turtl-block__container__iframe"
                [src]="turtleurl | sanitizeUrl"
                frameborder="0"
                allow="fullscreen"
                allowfullscreen="true"
                [style.height.px]="iframeHeight$$()"
            ></iframe>
        }
        @if (footnote) {
            <div [innerHTML]="footnote | sanitizeHtml"></div>
        }
    </div>
</nw-content-block>
